import { isBrowser } from '@/utils/browser';

export interface RecentStore {
  alias: string;
  domain: string;
}

export const RECENT_STORES_KEY = `loomi_recent_stores`;
const MAX_RECENT_STORES = 8;

function readRecentStores(): RecentStore[] {
  if (!isBrowser()) return [];
  try {
    const raw = window.localStorage.getItem(RECENT_STORES_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    console.warn(`Failed to parse recent stores from localStorage`, e);
    return [];
  }
}

function writeRecentStores(stores: RecentStore[]) {
  if (!isBrowser()) return;
  window.localStorage.setItem(RECENT_STORES_KEY, JSON.stringify(stores));
}

export function getRecentStores(): RecentStore[] {
  return readRecentStores();
}

export function addRecentStore(store: RecentStore): RecentStore[] {
  if (!store?.alias) return readRecentStores();

  const withoutCurrent = readRecentStores().filter(
    (s) => s.alias !== store.alias,
  );
  const updated = [store, ...withoutCurrent].slice(0, MAX_RECENT_STORES);

  writeRecentStores(updated);
  return updated;
}
